Verification is pending and requires user action.
